import {Component, EventEmitter, OnInit, Output, ViewChild} from "@angular/core";
import {
    FORM_DIRECTIVES,
    FORM_PROVIDERS,
    FormControl,
    FormGroup,
    REACTIVE_FORM_DIRECTIVES,
    Validators
} from "@angular/forms";
import {Router} from "@angular/router";
import {UserCredentials} from "../domain/userCredentials";
import {LoginService} from "../service/login.service";
import {MODAL_DIRECTIVES, ModalDirective} from "ng2-bootstrap";
import {User} from "../domain/user";
import {BankSelectorComponent} from "./bankSelector.component";
import {BankService} from "../service/bank.service";
import {Bank} from "../domain/bank";

@Component({
    selector: 'client-loggin',
    template: require('./clientLogin.component.html'),
    styles: [require('./clientLogin.component.css')],
    directives: [
        BankSelectorComponent,
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        MODAL_DIRECTIVES
    ],
    providers: [FORM_PROVIDERS]
})
export class ClientLoginComponent implements OnInit {

    @Output() close = new EventEmitter();

    private credentials:UserCredentials;

    public errorMessage:string;

    public form:FormGroup;

    public typeLogin:string;
    public patent:string;
    @ViewChild('bankSelectorModal') bankSelectorModal: ModalDirective;
    public cuit:string;

    public selectedBank: Bank;
    public banks: Bank[];
    private loggedUserBankId: string;

    constructor(private router:Router,
                private loginService:LoginService,
                private bankService: BankService) {
        this.init();
    }

    private init():void {
        this.credentials = new UserCredentials(null);
        this.credentials.isCuit = true;
        this.typeLogin = "cuit";

        let group:any = {};
        group['type'] = new FormControl('', [Validators.required]);
        group['patent'] = new FormControl('', [this.validateRequiredPatent.bind(this)]);
        group['cuit'] = new FormControl('', [this.validateRequiredCuit.bind(this)]);
        this.form = new FormGroup(group);
    }

    private validateRequiredPatent(group:FormControl) {
        if (this.typeLogin == "patent" && !this.patent) {
            return {
                required: true
            };
        }
        return null;
    }

    private validateRequiredCuit(group:FormControl):any {
        if (this.typeLogin == "cuit" && !this.cuit) {
            return {
                required: true
            };
        }
        return null;
    }

    public ngOnInit() {
        this.bankService.getBanksNoAuth().subscribe(
            this.setBanks.bind(this),
            () => {
                this.bindError('Ocurrió un error al obtener los bancos.')
            });
    }

    private setBanks(banks: Bank[]): void {
        this.banks = banks;
    }

    public showBankSelector(){
        this.bankSelectorModal.show();
    }

    public authenticate():void {
        if (this.typeLogin == 'cuit') {
            this.credentials.username = this.cuit;
            this.credentials.isCuit = true;
        } else {
            this.credentials.username = this.patent;
            this.credentials.isCuit = false;
        }
        this.credentials.bankId = this.selectedBank.id;

        this.loginService.authenticateClient(this.credentials).subscribe(
            () => {
                this.goToHome();
            },
            (error) => {
                if (error.status == '401') {
                    this.errorMessage = 'CUIT o patente inválido';
                } else {
                    this.bindError('Ocurrió un error');
                }
            });
    }

    private userLogged: User;
    private goToHome():void {
        this.loginService.getUserCredentialsByBank(this.credentials.bankId).subscribe(
            user => {
                this.userLogged = new User(user);
                this.loginService.setUserLogged(this.userLogged);

                this.updateUserLogged();

                if (this.bankSelectorModal) {
                    this.bankSelectorModal.hide();
                }
                if (this.selectedBank.id.toString() === this.loggedUserBankId && this.selectedBank.id.toString() != "") {
                    this.router.navigate(['app/home/client/home']);
                }
                // TODO: Testear bien si es necesario que este IGUAL al home component
                // (en principio no, porque solo entraria a este metodo si entra por patente)
            },
            ()=> {
                //Do Nothing.
            });

        // event.preventDefault();
        // this.router.navigate(['app/home/client/bankSelector']);
        //this.bankSelectorModal.show();
    }

    private updateUserLogged(): void {
        if (this.userLogged.rol && this.userLogged.rol.client && this.userLogged.bank && this.userLogged.bank.id) {
            this.loggedUserBankId = this.userLogged.bank.id.toString();
        }
    }

    public clearInputs():void {
        //Se hace esta negrada para que vuelve a ejecutar los validators
        this.patent = (this.patent == '') ? null : '';
        this.cuit = (this.cuit == '') ? null : '';
    }

    private bindError(messageError:string):void {
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/login/clientLogin.component.ts
 **/